import PropTypes from 'prop-types';
import React from 'react';

const AVATAR_COLORS = [
  '#1982c4', // Blue
  '#e63946', // Red
  '#2a9d8f', // Teal
  '#f9a825', // Yellow
  '#7c3aed', // Purple
  '#059669', // Green
  '#d97706', // Orange
  '#db2777', // Pink
  '#6366f1', // Indigo
  '#0891b2', // Cyan
];

const getInitials = (firstName, lastName) => {
  const first = firstName ? firstName.charAt(0).toUpperCase() : '';
  const last = lastName ? lastName.charAt(0).toUpperCase() : '';
  return first + last || '?';
};

const getColorFromName = (firstName, lastName) => {
  const name = `${firstName || ''}${lastName || ''}`;
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[index];
};

const TeamAvatar = ({ firstName, lastName, size = 'default' }) => {
  const initials = getInitials(firstName, lastName);
  const backgroundColor = getColorFromName(firstName, lastName);
  const sizeClass = size === 'small' ? 'team-avatar team-avatar-sm' : 'team-avatar';

  return (
    <div
      className={sizeClass}
      style={{ backgroundColor }}
      title={`${firstName || ''} ${lastName || ''}`.trim()}
    >
      {initials}
    </div>
  );
};

TeamAvatar.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  size: PropTypes.oneOf(['default', 'small'])
};

export default TeamAvatar;
